import '../../../../css/Animations.css';

import { Box, NumberFormatter, Stack } from '@mantine/core';
import React, { memo, useEffect, useRef } from 'react';

import { sumAllKeys } from '../../../../utils/statUtils';

const cellStyle = { display: 'flex', alignItems: 'center', gap: 16 };

const StatCell = memo(function StatCell({ value, round, invert }) {
    const currentValue = Number(value ?? 0) || 0;

    // previous value for direction (doesn't cause re-renders)
    const prevRef = useRef(currentValue);
    const prev = prevRef.current;

    useEffect(() => {
        prevRef.current = currentValue;
    }, [currentValue]);

    const changed = prev !== currentValue;
    const increased = changed && currentValue > prev;

    const animationClass = !changed
        ? ''
        : increased
        ? invert
            ? 'stats-down--fadein'
            : 'stats-up--fadein'
        : invert
        ? 'stats-up--fadein'
        : 'stats-down--fadein';

    return (
        <Box style={cellStyle}>
            <Stack gap={0}>
                <Box
                    // key change remounts this node => CSS animation restarts (no timeout needed)
                    key={changed ? `${prev}->${currentValue}` : 'stable'}
                    className={`stats ${animationClass}`}>
                    {round ? (
                        <NumberFormatter
                            value={currentValue}
                            decimalScale={2}
                            fixedDecimalScale
                            suffix='%'
                        />
                    ) : (
                        currentValue
                    )}
                </Box>
            </Stack>
        </Box>
    );
});

const StatColumn = (
    header,
    accessorKey,
    naiveRound = false,
    invert = false
) => ({
    id: header,
    header,
    size: 1,

    // compute once in the column accessor, not inside every render of the cell
    accessorFn: (row) => sumAllKeys(accessorKey(row)) || 0,

    Cell: ({ cell }) => (
        <StatCell
            value={cell.getValue()}
            round={naiveRound}
            invert={invert}
        />
    ),
});

export default StatColumn;
